import Store from "@ember-data/store";
export function initialize(owner) {
  const store = owner.lookup("service:store");
  const data = ["nephro", "pneumo", "hepato", "onco", "cardio", "mental", "rhumato", "diabeto", "digest", "generic"];
  data.forEach(id => {
    store.createRecord("therapeutical-area", {
      id
    });
  });
}
export default {
  initialize
};